import Enumerable from "linq";
import { HisInformationSetting } from "../../../../../base/domain/his";
import { Directory } from "../../../../../..//domain/drawing";

export class HisInformationDirectoryFactory {
  private _hisTypes: { [key in string]: string; } = {
    PATIENT: "患者情報",
    USER: "職員情報",
    MEDICAL: "診療情報",
    INSURANCE: "保険情報",
    DISEASE: "病名情報",
    HOSPITALIZATION: "入院情報",
    OPERATION: "手術情報",
    HOSPITAL: "医療機関情報",
    REPORT: "書類情報",
    WORKFLOW: "ワークフロー情報",
    LIS: "LIS情報",
    GENERAL: "汎用情報",
    REHABILI: "リハビリ情報",
    HOST: "端末情報",
  };
  
  create(items: HisInformationSetting[]): Directory<string, HisInformationSetting>[] {
    const directories = [] as Directory<string, HisInformationSetting>[];

    // 全て追加
    directories.push(new Directory<string, HisInformationSetting>(
      "ALL",
      "全て",
      [],
      items
    ));

    for (const key of Object.keys(this._hisTypes)) {
      if (Enumerable.from(items).any(i => i.itemType === key)) {
        const value = this._hisTypes[key];
        directories.push(new Directory<string, HisInformationSetting>(
          key,
          value,
          [],
          Enumerable.from(items).where(i => i.itemType === key).toArray()
        ));
      }
    }
    return directories;
  }
}
